export default __webpack_public_path__ + "static/media/Racional.b7c6d27a.svg";